import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Container } from "../../components/simple";
import ModalMessage from "../../components/complex/ModalMessage";
import { RestorePasswordModal } from "../../components/forms/Auth/RestorePassword";
import { userMessage } from "../../store/actions/auth";
import { paramsToObject } from "../../api/params";
import Api from "../../api";
import * as routes from "../../router/routes";

import "../../styles/shared/unauthed.scss";

function RestorePasswordScreen(props) {
  document.title = "Restore Password | Global Data Resources";

  const {
    location: { search },
    history,
    message,
    resetMessage
  } = props;
  const [isRestoreModal, handleStateRestoreModal] = useState(true);

  const closeWelcomeModal = () => {
    resetMessage();
    history.replace(routes.signIn);
  };

  const goBackActionRestore = () => {
    handleStateRestoreModal(!isRestoreModal);
    history.goBack();
  };

  const handleRestorePassword = async data => {
    const params = paramsToObject(search);
    await Api.user.restorePassword({
      data: { password: data.password, token: params.token, uid: params.uid }
    });
    setTimeout(() => {
      history.push(routes.signIn);
    }, 300);
  };

  return (
    <Container className="unauthed-container-background" fluid>
      <RestorePasswordModal
        isLoading={false}
        isOpen={isRestoreModal}
        goBackAction={goBackActionRestore}
        handleSubmit={handleRestorePassword}
      />
      <ModalMessage
        isOpen={!!message}
        goBackAction={closeWelcomeModal}
        title="Thanks!"
        message={message}
      />
    </Container>
  );
}

RestorePasswordScreen.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
    push: PropTypes.func,
    replace: PropTypes.func
  }).isRequired,
  message: PropTypes.string.isRequired,
  resetMessage: PropTypes.func.isRequired
};

const mapStateToProps = ({ userProfile }) => {
  return {
    message: userProfile.message
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetMessage: () => dispatch(userMessage(""))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RestorePasswordScreen);
